// TODO: SMOOTH OPENING ANIMATION
// TODO: MULTIPLE ACCORDIONS. MAYBE NEW ACCORDION GROUP COMPONENT AS WRAPPER?

import { Component, State, Event, EventEmitter, Prop, Host, h } from '@stencil/core';

@Component({
  tag: 'cwru-accordion',
  styleUrl: 'accordion.css',
  shadow: true,
})
export class Accordion {
  @State() toggled: boolean = false;

  @Event() toggle: EventEmitter;

  @Prop() heading: string;

  toggleComponent() {
    this.toggled = !this.toggled;
    this.toggle.emit({visible: this.toggled});
  }
  
  render() {
    return (
      <Host role="region">
        <h2 class="heading">
          <button aria-expanded={this.toggled ? 'true' : 'false'} onClick={() => this.toggleComponent()}>
            <div>{this.heading}</div>
          </button>
        </h2>
        <div class={`content ${this.toggled ? 'open' : 'closed'}`}>
          <slot />
        </div>
      </Host>
    );
  }
}
